import { types } from '~/utils/typeCreator'

export default types(['SET_IS_OPEN'], 'MODAL_INCOMPLETE_PROFILE')
